// Apolo IDE — BrainTab root (Sprint v2 Epic B6 WS B6.1).
//
// Side-panel tab that exposes Pedro's Brain (Obsidian vault via MCP)
// directly to the user — search, browse, quick actions. Status badge
// pinned to the header.

import { useState } from 'react';
import { Compass, Database, Search as SearchIcon, Sparkles } from 'lucide-react';
import BrainSearch from './brain/BrainSearch.jsx';
import BrainBrowse from './brain/BrainBrowse.jsx';
import BrainQuickActions from './brain/BrainQuickActions.jsx';
import BrainStatus from './brain/BrainStatus.jsx';
import CorpusIndexCard from './brain/CorpusIndexCard.jsx';

const SUB_TABS = [
  { id: 'search', label: 'Search', Icon: SearchIcon, Component: BrainSearch },
  { id: 'browse', label: 'Browse', Icon: Compass, Component: BrainBrowse },
  { id: 'actions', label: 'Quick', Icon: Sparkles, Component: BrainQuickActions },
  // sprint apolo-corpus — índice semântico LOCAL do vault (Fontes de Conhecimento)
  { id: 'index', label: 'Índice', Icon: Database, Component: CorpusIndexCard },
];

export default function BrainTab() {
  const [sub, setSub] = useState('search');
  const Body = SUB_TABS.find((t) => t.id === sub)?.Component || BrainSearch;
  return (
    <section aria-label="Pedro's Brain" className="flex h-full flex-col">
      <header className="flex items-center justify-between border-b border-apolo-borderSubtle px-3 py-2">
        <nav role="tablist" aria-label="Brain sub-tabs" className="flex items-center gap-1">
          {SUB_TABS.map((t) => {
            const isActive = t.id === sub;
            return (
              <button
                key={t.id}
                role="tab"
                aria-selected={isActive}
                onClick={() => setSub(t.id)}
                className={`inline-flex items-center gap-1 rounded-md px-2 py-1 text-xs transition focus:outline-none focus:ring-2 focus:ring-apolo-accent/50 ${
                  isActive
                    ? 'bg-apolo-surface2 text-apolo-textPrimary'
                    : 'text-apolo-textTertiary hover:text-apolo-textSecondary'
                }`}
              >
                <t.Icon size={11} aria-hidden="true" />
                <span>{t.label}</span>
              </button>
            );
          })}
        </nav>
        <BrainStatus />
      </header>
      <div className="flex-1 overflow-y-auto">
        <Body />
      </div>
    </section>
  );
}
